<template lang="pug">
  yz-dialog(v-model="showDialog" persistent scrollable max-width="500px")
    yz-card
      yz-dialog-normal-header(title="Revert panel claim to invoice" @close="onClose")

      yz-dialog-normal-content.px-6.py-6
        .d-flex.align-start.gap-2
          yz-icon.mt-1(color="yz-danger-500" size="20px") $yzi-alert-circle
          .text-neutral-700.yz-medium-body-md This panel claim will be converted back to its original Invoice state.
        .text-neutral-700.mt-2
          .yz-regular-body-sm.mb-2 The panel claim number will be removed. You can edit the invoice details again before resubmitting.
          .yz-regular-body-sm Click "Confirm" to continue.

      yz-dialog-normal-actions
        .d-flex.align-center.gap-3.justify-end
          yz-btn(size="lg" text label="Cancel" :disabled="loading" @click="onClose")
          yz-btn(size="lg" label="Confirm" color="danger" :loading="loading" @click="onConfirm")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    parentClaim: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      loading: false
    }
  },
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    async onConfirm() {
      this.loading = true
      try {
        await this.$axios.delete(`/panels/${this.company.slug}/claims/${this.parentClaim.id}`)
        await this.showMessage(['success', 'Panel claim has been reverted to invoice successfully'])
        this.$emit('confirm')
        this.showDialog = false
      } catch (error) {
        console.error(error)
        await this.showMessage(['error', error.response?.data?.message || 'Failed to revert claim. Please try again.'])
      } finally {
        this.loading = false
      }
    },
    onClose() {
      this.$emit('close')
      this.showDialog = false
    }
  }
}
</script>

<style scoped></style>
